{
	"type": "line",
	"minzoom": 7,
	"layout": {
		"line-sort-key": [
			"match",
			["get", "priority_rating"],
			"HIGH",
			5,
			"MEDIUM-HIGH",
			4,
			"MEDIUM",
			3,
			"LOW-MEDIUM",
			2,
			"LOW",
			1,
			0
		]
	},
	"paint": {
		"line-color": [
			"match",
			["get", "priority_rating"],
			"HIGH",
			"#000000",
			"MEDIUM-HIGH",
			"#ED2938",
			"MEDIUM",
			"#FFAA1C",
			"LOW-MEDIUM",
			"#FFE733",
			"LOW",
			"#41C300",
			"UNKNOWN",
			"#aaa",
			"#ddd"
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 2, 18, 12],
		"line-blur": 1,
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 0.9, 0], 11, 0.9],
		"line-dasharray": ["match", ["get", "road_seal"], 0, ["literal", [2, 1]], ["literal", [1, 0]]]
	}
}
